import { Typography } from '@iheartjane/reefer';
import { useFormContext } from '@iheartjane/reefer-hook-form';
import { useEffect } from 'react';

import { QuillEditor } from './QuillEditor';

import styles from './richEditor.module.css';

export interface RichEditorProps {
  defaultValue?: string;
  onChange?: (htmlValue: string) => void;
}

export const RichEditor = ({ defaultValue, onChange }: RichEditorProps) => {
  const {
    setValue,
    getValues,
    setError,
    formState: { errors },
    clearErrors,
  } = useFormContext();

  useEffect(() => {
    setValue('message', defaultValue, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  }, []);

  const handleChange = (htmlValue: string) => {
    setValue('message', htmlValue, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    const message = getValues('message');

    if (!message || message === '<p><br></p>') {
      setError('messageField', {
        type: 'onChange',
        message: 'message is required',
      });
    } else {
      clearErrors('messageField');
    }

    onChange && onChange(message);
  };

  return (
    <>
      <div className={styles['container']}>
        <QuillEditor defaultValue={defaultValue} onChange={handleChange} />
      </div>
      {errors['messageField'] ? (
        <Typography mt={16} color="error">
          Please fill out this field.
        </Typography>
      ) : null}
    </>
  );
};
